// Phase 6 — Track D T-D3. useAlerts hook.

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { AlertWithPinned } from '@dailydeck/shared/types';
import { apiClient } from '../app/apiClient.js';

export type AlertsPriorityFilter = 'all' | 'critical' | 'important' | 'info';

export interface UseAlertsArgs {
  priority?: AlertsPriorityFilter;
}

export const ALERTS_QUERY_KEY = 'alerts' as const;

export function useAlerts(args: UseAlertsArgs = {}): UseQueryResult<readonly AlertWithPinned[], Error> {
  const priority = args.priority ?? 'all';
  return useQuery<readonly AlertWithPinned[], Error>({
    queryKey: [ALERTS_QUERY_KEY, priority],
    queryFn: () => apiClient.alerts.list(priority === 'all' ? {} : { priority }),
  });
}
